module.exports = __webpack_public_path__ + "static/media/gif-load.92528395.gif";